import React from "react";
import styles from "./Home.module.css";

const Home = () => {
  return (
    <div className={styles.pageContainer}>
      <section className={styles.hero}>
        <h1>Easiest invoicing for freelancers and small businesses</h1>
        <div className={styles.paragraph}>
          <p>
            Free and Open Source Invoicing application made with MongoDB,
            Express, React & Nodejs
          </p>
        </div>
        <div className={styles.imgContainer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1000 600"
            id="budgeting"
          >
            <g>
              <path
                fill="#a9c0ff"
                d="M771.52148 300.00293H731.68115a1.5 1.5 0 010-3h39.84033a1.5 1.5 0 010 3zM771.52148 310.083H731.68115a1.5 1.5 0 010-3h39.84033a1.5 1.5 0 010 3zM771.52148 320.16309H731.68115a1.5 1.5 0 110-3h39.84033a1.5 1.5 0 010 3z"
              ></path>
              <circle
                cx="399.457"
                cy="294.002"
                r="182.397"
                fill="#d9ebff"
              ></circle>
              <rect
                width="46.323"
                height="46.323"
                x="495.106"
                y="415.788"
                fill="#a9c0ff"
              ></rect>
              <circle
                cx="655.811"
                cy="395.995"
                r="51.334"
                fill="#d9ebff"
              ></circle>
              <circle
                cx="677.908"
                cy="183.668"
                r="80.282"
                fill="#d9ebff"
              ></circle>
              <path
                fill="#a9c0ff"
                d="M333.00342 127.1123H293.16357a1.5 1.5 0 010-3h39.83985a1.5 1.5 0 010 3zM333.00342 137.19238H293.16357a1.5 1.5 0 010-3h39.83985a1.5 1.5 0 010 3zM333.00342 147.27246H293.16357a1.5 1.5 0 010-3h39.83985a1.5 1.5 0 010 3zM771.52148 142.1543H731.68115a1.5 1.5 0 010-3h39.84033a1.5 1.5 0 010 3zM771.52148 152.23438H731.68115a1.5 1.5 0 010-3h39.84033a1.5 1.5 0 010 3zM771.52148 162.31445H731.68115a1.5 1.5 0 010-3h39.84033a1.5 1.5 0 010 3z"
              ></path>
              <rect
                width="637.92"
                height="9"
                x="166.146"
                y="476.511"
                fill="#456ba3"
              ></rect>
              <path
                fill="#6299e8"
                d="M495.10556,459.11107V418.78825a3,3,0,0,0-3-3h-8.3999a3,3,0,0,0-3,3v54.72284a3,3,0,0,0,3,3h54.7229a3,3,0,0,0,3-3v-8.4a3,3,0,0,0-3-3h-40.323A3,3,0,0,1,495.10556,459.11107Z"
              ></path>
              <path
                fill="#c2d5ff"
                d="M525.467,462.11107v14.4H568.79a3,3,0,0,0,3-3v-8.4a3,3,0,0,0-3-3Z"
              ></path>
              <rect
                width="266.4"
                height="192.863"
                x="366.798"
                y="222.925"
                fill="#6299e8"
                rx="6"
              ></rect>
              <path
                fill="#4d76b8"
                d="M627.19775,417.28809H372.79736a7.50852,7.50852,0,0,1-7.5-7.5V228.9248a7.50852,7.50852,0,0,1,7.5-7.5H627.19775a7.50851,7.50851,0,0,1,7.5,7.5V409.78809A7.50851,7.50851,0,0,1,627.19775,417.28809ZM372.79736,224.4248a4.50493,4.50493,0,0,0-4.5,4.5V409.78809a4.50493,4.50493,0,0,0,4.5,4.5H627.19775a4.50492,4.50492,0,0,0,4.5-4.5V228.9248a4.50492,4.50492,0,0,0-4.5-4.5Z"
              ></path>
              <rect
                width="266.4"
                height="192.863"
                x="383.506"
                y="222.925"
                fill="#fff"
                rx="6"
              ></rect>
              <rect
                width="226.1"
                height="153.276"
                x="403.656"
                y="242.718"
                fill="#d9ebff"
                rx="6"
              ></rect>
              <path
                fill="#4d76b8"
                d="M643.90576,417.28809H389.50586a7.50852,7.50852,0,0,1-7.5-7.5V228.9248a7.50852,7.50852,0,0,1,7.5-7.5h254.3999a7.5082,7.5082,0,0,1,7.5,7.5V409.78809A7.5082,7.5082,0,0,1,643.90576,417.28809ZM389.50586,224.4248a4.50492,4.50492,0,0,0-4.5,4.5V409.78809a4.50492,4.50492,0,0,0,4.5,4.5h254.3999a4.50492,4.50492,0,0,0,4.5-4.5V228.9248a4.50492,4.50492,0,0,0-4.5-4.5Z"
              ></path>
              <path
                fill="#a9c0ff"
                d="M623.75547 242.71849H409.65586a6 6 0 00-6 6v16.52179H629.75547V248.71849A6 6 0 00623.75547 242.71849zM403.65586 376.84794v13.14691a6 6 0 006 6H623.75547a6 6 0 006-6V376.84794z"
              ></path>
              <rect
                width="79.2"
                height="2"
                x="534.226"
                y="278.323"
                fill="#456ba3"
              ></rect>
              <rect
                width="79.2"
                height="2"
                x="534.226"
                y="295.406"
                fill="#456ba3"
              ></rect>
              <rect
                width="79.2"
                height="2"
                x="534.226"
                y="312.488"
                fill="#456ba3"
              ></rect>
              <rect
                width="193.12"
                height="2"
                x="420.306"
                y="329.572"
                fill="#456ba3"
              ></rect>
              <rect
                width="193.12"
                height="2"
                x="420.306"
                y="346.655"
                fill="#456ba3"
              ></rect>
              <rect
                width="193.12"
                height="2"
                x="420.306"
                y="363.738"
                fill="#456ba3"
              ></rect>
              <g opacity=".28">
                <rect
                  width="157.416"
                  height="113.963"
                  x="547.158"
                  y="185.392"
                  fill="#6299e8"
                  rx="6"
                ></rect>
              </g>
              <rect
                width="157.416"
                height="113.963"
                x="562.278"
                y="170.588"
                fill="#fff"
                rx="6"
              ></rect>
              <path
                fill="#4d76b8"
                d="M713.69336,286.05078H568.27783a7.5082,7.5082,0,0,1-7.5-7.5V176.58789a7.5082,7.5082,0,0,1,7.5-7.5H713.69336a7.5082,7.5082,0,0,1,7.5,7.5V278.55078A7.5082,7.5082,0,0,1,713.69336,286.05078ZM568.27783,172.08789a4.50493,4.50493,0,0,0-4.5,4.5V278.55078a4.50492,4.50492,0,0,0,4.5,4.5H713.69336a4.50492,4.50492,0,0,0,4.5-4.5V176.58789a4.50493,4.50493,0,0,0-4.5-4.5Z"
              ></path>
              <rect
                width="3"
                height="64.651"
                x="584.766"
                y="195.243"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="64.651"
                x="612.125"
                y="195.243"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="64.651"
                x="639.486"
                y="195.243"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="64.651"
                x="666.846"
                y="195.243"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="64.651"
                x="694.206"
                y="195.243"
                fill="#4d76b8"
              ></rect>
              <rect
                width="130.56"
                height="3"
                x="575.836"
                y="212.391"
                fill="#4d76b8"
              ></rect>
              <rect
                width="130.56"
                height="3"
                x="575.836"
                y="239.751"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="21.247"
                x="653.056"
                y="216.281"
                fill="#4d76b8"
                transform="rotate(-48.206 654.555 226.904)"
              ></rect>
              <rect
                width="21.247"
                height="3"
                x="643.932"
                y="225.405"
                fill="#4d76b8"
                transform="rotate(-41.793 654.555 226.904)"
              ></rect>
              <g opacity=".28">
                <rect
                  width="97.134"
                  height="70.321"
                  x="416.1"
                  y="136.236"
                  fill="#6299e8"
                  rx="6"
                ></rect>
              </g>
              <rect
                width="97.134"
                height="70.321"
                x="425.429"
                y="127.101"
                fill="#fff"
                rx="6"
              ></rect>
              <path
                fill="#4d76b8"
                d="M516.563,198.92285H431.4292a7.5082,7.5082,0,0,1-7.5-7.5V133.10156a7.5082,7.5082,0,0,1,7.5-7.5H516.563a7.5082,7.5082,0,0,1,7.5,7.5v58.32129A7.5082,7.5082,0,0,1,516.563,198.92285ZM431.4292,128.60156a4.50492,4.50492,0,0,0-4.5,4.5v58.32129a4.50491,4.50491,0,0,0,4.5,4.5H516.563a4.50492,4.50492,0,0,0,4.5-4.5V133.10156a4.50493,4.50493,0,0,0-4.5-4.5Z"
              ></path>
              <path
                fill="#a9c0ff"
                d="M513.227,146.48727a15.40172,15.40172,0,0,1-2.87242-.258,11.6974,11.6974,0,0,0-.346-8.07483c-.018-.03687-.03686-.07182-.05793-.1066a4.12312,4.12312,0,0,0-4.28627-2.17363,4.33925,4.33925,0,0,0-3.78681,3.27248c-.00941.03256-.01755.06559-.02553.09926-.667,3.07986.5073,5.6762,3.40413,7.5163a13.70327,13.70327,0,0,0,2.04085,1.04668,28.992,28.992,0,0,1-1.54472,3.171q-.68627,1.23514-1.54472,2.55326a1.198,1.198,0,0,0,2.00718,1.30838c.30049-.45942.58725-.91566.859-1.36455a33.48346,33.48346,0,0,0,2.5116-4.94694,17.68716,17.68716,0,0,0,3.64159.36224,1.19684,1.19684,0,1,0,0-2.39367Zm-5.16891-.95748a11.084,11.084,0,0,1-1.52716-.79789c-2.03463-1.29211-2.78274-2.86108-2.35187-4.93257a1.9715,1.9715,0,0,1,1.7777-1.55589,1.75914,1.75914,0,0,1,1.90185.96752,9.38432,9.38432,0,0,1,.20443,6.31452l-.005.00941Zm0,0"
              ></path>
              <rect
                width="81.066"
                height="53.14"
                x="433.463"
                y="135.692"
                fill="none"
              ></rect>
              <path
                fill="#92b1ef"
                d="M507.07385,153.47265c-.27176.44809-.55852.90449-.859,1.36392a1.19666,1.19666,0,0,1-2.004-1.30839q.85742-1.312,1.54472-2.55326a15.92615,15.92615,0,0,1,1.31828,2.49773Zm.9862-7.94286a9.4237,9.4237,0,0,0-.20442-6.31452,1.75926,1.75926,0,0,0-1.90186-.96673,1.95908,1.95908,0,0,0-1.77787,1.55589c-.4307,2.07452.31916,3.63967,2.35188,4.93258a11.181,11.181,0,0,0,1.52732.79788c-.1291-.03813-4.26872-1.286-4.26872-4.60032,0-1.81967.71682-2.87242,2.05824-3.04205,1.34206-.169,2.41793.53986,2.80762,2.41108a8.83139,8.83139,0,0,1-.59219,5.22619Zm0,0"
              ></path>
              <path
                fill="#a9c0ff"
                d="M508.56432,148.20656l-.06112-.01628h-.02059Zm-.897,12.83489c0,6.71778-3.12614,12.55053-9.29353,17.346l-.02122.01548-.27926.21575-.02554.01931c-.10037.07787-.20266.15958-.30479.22947l-.05123.03671c-.15958.10532-.31915.21878-.47873.33654v8.3624a.086.086,0,0,1,0,.02553A1.19474,1.19474,0,0,1,496.0181,188.8h-6.92236a1.19808,1.19808,0,0,1-1.1638-.91327l-.06176-.258-.6289-2.57257-.17888-.73054q-.37583.11393-.75609.22005a44.31791,44.31791,0,0,1-11.96838,1.554,43.36257,43.36257,0,0,1-12.89107-1.8476l-.87257,3.62849a1.19685,1.19685,0,0,1-1.16317.91758H452.495a1.19625,1.19625,0,0,1-1.19684-1.19684v-8.20712a27.13727,27.13727,0,0,1-5.68753-3.48822,42.71781,42.71781,0,0,1-5.16764-4.56235,11.83576,11.83576,0,0,1-4.9356-3.07683,7.57324,7.57324,0,0,1-1.91494-5.70493.37444.37444,0,0,1,.01118-.11155,9.39986,9.39986,0,0,1,1.572-4.23011,4.49179,4.49179,0,0,1,4.81113-1.66121,1.6257,1.6257,0,0,0,1.75537-.95747c.053-.20952.10851-.404.17074-.58293a19.49169,19.49169,0,0,1,3.66217-6.81879l-1.34333-8.05376a1.19693,1.19693,0,0,1,1.74116-1.26228l6.19164,3.28382c6.23489-4.17586,13.69135-6.29218,22.18141-6.29218,9.096,0,16.9758,2.43739,23.40505,7.24039a24.05933,24.05933,0,0,1,8.58245,10.56265,20.05559,20.05559,0,0,1,1.33391,7.36311Zm0,0"
              ></path>
              <path d="M508.48261,148.1823l.08171.02234-.06112-.01612Zm0,0"></path>
              <path
                fill="#4d76b8"
                d="M452.6651,154.09979a2.67,2.67,0,0,1,.84273,1.94479,2.89694,2.89694,0,0,1-2.78751,2.7864,2.66356,2.66356,0,0,1-1.93745-.85024,2.61761,2.61761,0,0,1-.75305-1.93616,2.57993,2.57993,0,0,1,2.6905-2.69848,2.62982,2.62982,0,0,1,1.94478.75369Zm0,0"
              ></path>
              <path
                fill="#92b1ef"
                d="M437.81186,163.33906c0,2.49709-.99545,4.57049-2.30448,4.98874a7.57474,7.57474,0,0,1-1.91494-5.70492.37661.37661,0,0,1,.01118-.11219,9.30884,9.30884,0,0,1,1.569-4.2301c1.47115.14649,2.63927,2.35505,2.63927,5.05847Zm0,0"
              ></path>
              <path
                fill="#4d76b8"
                d="M435.96554 163.28178c0-1.07094-.222-1.93936-.49629-1.93936-.27416 0-.49613.86842-.49613 1.93936s.222 1.93855.49613 1.93855c.27431 0 .49629-.86762.49629-1.93855zm0 0M434.48943 162.95943c0-.98492-.20458-1.78281-.45639-1.78281s-.45624.79789-.45624 1.78281c0 .98428.20442 1.78217.45624 1.78217s.45639-.79789.45639-1.78217zm0 0"
              ></path>
              <path
                fill="#92b1ef"
                d="M497.213,179.3001v.99417c-1.83324.98492-5.66312,2.96657-9.97174,4.82407l-.177-.72434c1.99474-.89076,7.48583-3.49811,10.14872-5.0939Zm-45.91487.15639s6.9522,4.0568,10.1519,4.859l-.19261.79789a61.19248,61.19248,0,0,1-9.95929-5.11576Zm51.99194-34.33985s3.0114,3.7694,9.93695,3.7643a1.23647,1.23647,0,0,0,1.19684-1.19684,1.34778,1.34778,0,0,1-1.28908.95747,15.96757,15.96757,0,0,1-9.84471-3.52493Zm0,0"
              ></path>
              <path
                fill="#4d76b8"
                d="M682.40234 236.98145a8.09083 8.09083 0 118.09082-8.09083A8.10014 8.10014 0 01682.40234 236.98145zm0-13.18165a5.09083 5.09083 0 105.09082 5.09082A5.09685 5.09685 0 00682.40234 223.7998zM797.53564 226.1709a16.30371 16.30371 0 1116.3042-16.30371A16.32216 16.32216 0 01797.53564 226.1709zm0-29.60742a13.30371 13.30371 0 1013.3042 13.30371A13.31887 13.31887 0 00797.53564 196.56348z"
              ></path>
              <path
                fill="#4d76b8"
                d="M797.53564 218.18359a8.31592 8.31592 0 118.31592-8.3164A8.32539 8.32539 0 01797.53564 218.18359zm0-13.63183a5.31592 5.31592 0 105.31592 5.31543A5.3219 5.3219 0 00797.53564 204.55176zM764.30225 240.15723h-4.03467a7.01527 7.01527 0 01-7.00733-7.00684 3.97966 3.97966 0 00-1.20312-2.86328 3.91345 3.91345 0 00-2.88818-1.14356l-60.14454 1.24707-.0625-3 60.145-1.24707a7.00848 7.00848 0 017.15332 7.00684 4.012 4.012 0 004.00733 4.00684h4.03467a4.012 4.012 0 004.00732-4.00684V215.375a7.01546 7.01546 0 017.00732-7.00781h8.37549v3h-8.37549a4.01219 4.01219 0 00-4.00732 4.00781v17.77539A7.01526 7.01526 0 01764.30225 240.15723z"
              ></path>
              <g opacity=".28">
                <rect
                  width="54.295"
                  height="79.887"
                  x="767.079"
                  y="249.538"
                  fill="#6299e8"
                  rx="3"
                ></rect>
              </g>
              <rect
                width="55.873"
                height="79.887"
                x="777.981"
                y="240.816"
                fill="#a9c0ff"
                rx="3"
              ></rect>
              <rect
                width="22.738"
                height="2"
                x="787.489"
                y="261.526"
                fill="#4d76b8"
              ></rect>
              <rect
                width="27.155"
                height="2"
                x="787.489"
                y="254.166"
                fill="#4d76b8"
              ></rect>
              <rect
                width="37.706"
                height="2"
                x="787.489"
                y="268.888"
                fill="#456ba3"
              ></rect>
              <rect
                width="37.706"
                height="23.396"
                x="787.489"
                y="283.992"
                fill="#fafafa"
                rx="2"
              ></rect>
              <rect
                width="1.999"
                height="34.699"
                x="805.34"
                y="278.24"
                fill="#4d76b8"
                transform="rotate(-62.505 806.34 295.59)"
              ></rect>
              <rect
                width="34.699"
                height="1.999"
                x="788.99"
                y="294.59"
                fill="#4d76b8"
                transform="rotate(-27.504 806.34 295.59)"
              ></rect>
              <rect
                width="88.97"
                height="34.165"
                x="420.306"
                y="279.323"
                fill="#a9c0ff"
                rx="2"
              ></rect>
              <rect
                width="112.32"
                height="140.946"
                x="655.521"
                y="335.137"
                fill="#d9ebff"
                rx="3"
              ></rect>
              <path
                fill="#4d76b8"
                d="M764.84131,477.583H658.52148a4.50493,4.50493,0,0,1-4.5-4.5V338.1377a4.50492,4.50492,0,0,1,4.5-4.5H764.84131a4.50492,4.50492,0,0,1,4.5,4.5V473.083A4.50493,4.50493,0,0,1,764.84131,477.583ZM658.52148,336.6377a1.50164,1.50164,0,0,0-1.5,1.5V473.083a1.50164,1.50164,0,0,0,1.5,1.5H764.84131a1.50164,1.50164,0,0,0,1.5-1.5V338.1377a1.50164,1.50164,0,0,0-1.5-1.5Z"
              ></path>
              <rect
                width="112.32"
                height="3"
                x="655.521"
                y="356.219"
                fill="#4d76b8"
              ></rect>
              <rect
                width="112.32"
                height="3"
                x="655.521"
                y="378.802"
                fill="#4d76b8"
              ></rect>
              <rect
                width="112.32"
                height="3"
                x="655.521"
                y="402.385"
                fill="#4d76b8"
              ></rect>
              <rect
                width="112.32"
                height="3"
                x="655.521"
                y="425.967"
                fill="#4d76b8"
              ></rect>
              <rect
                width="112.32"
                height="3"
                x="655.521"
                y="449.55"
                fill="#4d76b8"
              ></rect>
              <rect
                width="7.2"
                height="3"
                x="752.361"
                y="345.602"
                fill="#4d76b8"
              ></rect>
              <rect
                width="7.2"
                height="3"
                x="738.921"
                y="345.602"
                fill="#4d76b8"
              ></rect>
              <rect
                width="7.2"
                height="3"
                x="725.481"
                y="345.602"
                fill="#4d76b8"
              ></rect>
              <rect
                width="7.2"
                height="3"
                x="712.042"
                y="345.602"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="119.297"
                x="673.461"
                y="356.719"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="119.297"
                x="697.941"
                y="356.719"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="119.297"
                x="722.421"
                y="356.719"
                fill="#4d76b8"
              ></rect>
              <rect
                width="3"
                height="119.297"
                x="746.901"
                y="356.719"
                fill="#4d76b8"
              ></rect>
              <path
                fill="#6299e8"
                d="M196.52476,475.49165h46.15946a11.48041,11.48041,0,0,1-11.1608-8.79036l-14.92808-61.93567a11.48039,11.48039,0,0,0-11.16079-8.79036h-3.74588a11.4804,11.4804,0,0,0-11.16851,14.13822l12.43641,52.25939a11.4804,11.4804,0,0,1-11.16851,14.13822h0Z"
              ></path>
              <path
                fill="#4d76b8"
                d="M199.88892 395.87332h46.15945l.10781 0L261.205 461.44317a11.4804 11.4804 0 01-11.18948 14.04848h-7.3313a11.48041 11.48041 0 01-11.1608-8.79036l-14.92808-61.93567a11.48039 11.48039 0 00-11.16079-8.79036zM176.14566 453.98145l4.65938 14.39189a11.48041 11.48041 0 0010.983 8.13775h0a11.4804 11.4804 0 0011.16851-14.13822l-1.99695-8.39142z"
              ></path>
              <path
                fill="#6299e8"
                d="M250.01552,475.49165A11.4804,11.4804,0,0,0,261.205,461.44317l-24.9503-108.712a11.4804,11.4804,0,0,1,11.18949-14.04847h4.47245l62.3413,14.04847,24.95029,108.712a11.4804,11.4804,0,0,1-11.18948,14.04848H250.01552Z"
              ></path>
              <path
                fill="#4d76b8"
                d="M325.44742,338.68269h4.47245a11.4804,11.4804,0,0,1,11.03131,8.30078l5.20536,18.05942a11.4804,11.4804,0,0,0,11.0313,8.30078H279.18461a11.48039,11.48039,0,0,1-11.0313-8.30078L262.948,346.98347a11.48041,11.48041,0,0,0-11.03131-8.30078Z"
              ></path>
              <path
                fill="#92b1ef"
                d="M279.18461,373.34367h1.25566a11.4804,11.4804,0,0,0,11.16152-14.16743l-1.89042-7.85249h78.00324l1.89041,7.85249a11.4804,11.4804,0,0,1-11.16152,14.16743H279.18461Z"
              ></path>
              <rect
                width="48.96"
                height="3"
                x="254.705"
                y="390.807"
                fill="#4d76b8"
              ></rect>
              <rect
                width="6.48"
                height="3"
                x="309.843"
                y="390.807"
                fill="#4d76b8"
              ></rect>
              <rect
                width="48.96"
                height="3"
                x="258.064"
                y="403.887"
                fill="#4d76b8"
              ></rect>
              <rect
                width="6.48"
                height="3"
                x="313.203"
                y="403.887"
                fill="#4d76b8"
              ></rect>
              <rect
                width="48.96"
                height="3"
                x="261.501"
                y="417.086"
                fill="#4d76b8"
              ></rect>
              <rect
                width="6.48"
                height="3"
                x="316.64"
                y="417.086"
                fill="#4d76b8"
              ></rect>
              <rect
                width="48.96"
                height="3"
                x="264.937"
                y="430.286"
                fill="#4d76b8"
              ></rect>
              <rect
                width="6.48"
                height="3"
                x="320.076"
                y="430.286"
                fill="#4d76b8"
              ></rect>
              <rect
                width="48.96"
                height="3"
                x="268.373"
                y="443.486"
                fill="#4d76b8"
              ></rect>
              <rect
                width="6.48"
                height="3"
                x="323.512"
                y="443.486"
                fill="#4d76b8"
              ></rect>
              <rect
                width="48.96"
                height="3"
                x="271.81"
                y="456.687"
                fill="#4d76b8"
              ></rect>
              <rect
                width="6.48"
                height="3"
                x="326.948"
                y="456.687"
                fill="#4d76b8"
              ></rect>
              <rect
                width="26.995"
                height="3"
                x="203.322"
                y="415.111"
                fill="#4d76b8"
              ></rect>
              <rect
                width="26.995"
                height="3"
                x="205.175"
                y="428.191"
                fill="#4d76b8"
              ></rect>
              <rect
                width="26.995"
                height="3"
                x="207.07"
                y="441.391"
                fill="#4d76b8"
              ></rect>
              <rect
                width="26.995"
                height="3"
                x="208.964"
                y="454.591"
                fill="#4d76b8"
              ></rect>
              <g opacity=".28">
                <rect
                  width="126.815"
                  height="98.025"
                  x="264.075"
                  y="192.371"
                  fill="#6299e8"
                  rx="2"
                ></rect>
              </g>
              <rect
                width="126.815"
                height="98.025"
                x="247.384"
                y="177.363"
                fill="#fff"
                rx="2"
              ></rect>
              <path
                fill="#4d76b8"
                d="M372.19873,276.8877H249.38428a3.50425,3.50425,0,0,1-3.5-3.5V179.36328a3.50424,3.50424,0,0,1,3.5-3.5H372.19873a3.50424,3.50424,0,0,1,3.5,3.5V273.3877A3.50425,3.50425,0,0,1,372.19873,276.8877ZM249.38428,178.86328a.50065.50065,0,0,0-.5.5V273.3877a.50065.50065,0,0,0,.5.5H372.19873a.50065.50065,0,0,0,.5-.5V179.36328a.50065.50065,0,0,0-.5-.5Z"
              ></path>
              <rect
                width="63.614"
                height="42.817"
                x="283.952"
                y="192.371"
                fill="#a9c0ff"
                rx="2"
              ></rect>
              <rect
                width="63.614"
                height="8.971"
                x="283.952"
                y="198.862"
                fill="#d9ebff"
              ></rect>
              <path
                fill="#4d76b8"
                d="M337.47319,213.50785a1.85032,1.85032,0,0,0-1.69909-1.97095H283.95178v21.68042a1.85016,1.85016,0,0,0,1.6991,1.97094h57.83343Z"
              ></path>
              <rect
                width="63.614"
                height="42.817"
                x="269.272"
                y="217.399"
                fill="#92b1ef"
                rx="2"
              ></rect>
              <rect
                width="53.216"
                height="6.728"
                x="274.267"
                y="247.575"
                fill="#4d76b8"
              ></rect>
              <g opacity=".61">
                <circle
                  cx="279.67"
                  cy="230.805"
                  r="4.893"
                  fill="#a9c0ff"
                ></circle>
              </g>
              <g opacity=".61">
                <circle
                  cx="285.787"
                  cy="230.805"
                  r="4.893"
                  fill="#a9c0ff"
                ></circle>
              </g>
            </g>
          </svg>
        </div>
      </section>
    </div>
  );
};

export default Home;
